module.exports = "<div class=\"column\"\r\n  [ngClass]=\"{'xs': xs, 's': s, 'm': m, 'l': l}\"\r\n  [ngStyle]=\"{'justify-content': align, 'align-items': horizontalAlign, 'background': background, 'height': height, 'width': width, 'padding': padding, 'margin': margin}\">\r\n  <ng-content></ng-content>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/column/column.component.html
// module id = ./src/app/components/column/column.component.html
// module chunks = main